import React from 'react'
import { useState, useEffect } from 'react'
import TableSubjects from './TableSubjects'
import { useBranchStore, useSectionStore, useSubjectStore, useUserStore } from '../../stores'
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer, toast } from "react-toastify";
import { Accordion } from "react-bootstrap";
import { useImmer } from 'use-immer';
import { useRef } from 'react';
import DeleteModal from '../admin/DeleteModal';
import { handleXhrError } from '../../utils';
import RepeatableTableRows from '../skeletons/RepeatableTableRows';
const MySwal = withReactContent(Swal);
const toastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

const CollapseArcadian = ({ year, children, index }) => {
    const body = useRef(null);
    const scroll = (e) => {
        body.current.scrollIntoView(false);
        console.log(body.current);
    }
    return (
        <Accordion.Item eventKey={index}>
            <Accordion.Header onClick={scroll}>Year-{year} </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
            <div ref={body}></div>
        </Accordion.Item>)
}
const filterSubjects = (data, year, sem) => {
    console.log(data);
    return data.filter(d => d.year == year && d.sem == sem)
}
const YearCollapseSubject = ({ setOpenModal, sem, yearSelected }) => {
    const deleteSubRef = useRef({});
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const subjects = useSubjectStore((state) => state.subjects);
    const branchId = useBranchStore(state => state.branchId);
    const currentBranch = useBranchStore(state => state.currentBranch);
    const years = currentBranch.years || [];
    const initAddSubjectStore = useSubjectStore((state) => state.initAddSubjectStore);
    const setSubjectsLoading = useSubjectStore((state) => state.setSubjectsLoading);
    const IssubjectsLoading = useSubjectStore((state) => state.loading);
    const currentAllBatches = useSubjectStore((state) => state.currentAllBatches);
    useEffect(() => {
        // getCurrentBatch from branch
        setSubjectsLoading(true);
        if (!branchId) {
            return;
        }
        window.$.ajax({
            type: "get",
            url: "/api/course/subjects?show=degree&branch=" + branchId,
            xhrFields: {
                withCredentials: true,
            },
            dataType: "json",
            success: (response, textStatus, request) => {
                console.log(response);
                initAddSubjectStore(response.subjects, currentBranch);
            },
            statusCode: {

                404: function () {

                    toast.error("page not found", toastOptions);
                },
                400: function (res) {
                    if (!res.responseJSON) {
                        toast.error("Something went wrong...", toastOptions);
                        return;
                    }

                    toast.error(res.responseJSON.message, toastOptions);
                    return;
                },
            },
            headers: {
                "Access-Control-Allow-Credentials": true,
                "Access-Control-Allow-Origin": "",
            },
            error: function (res, textStatus, err) {
                handleXhrError(res, textStatus, err, () => {
                    //   e.target.disabled = false;
                })
            },
        });
    }, [branchId]);
    // fetching data zustand,sections,branch,sem
    if (IssubjectsLoading) {
        return (
            <div className="container p-0">
                <div className='row'><RepeatableTableRows backgroundColor="#bcc6fb" rows={currentBranch.duration} /></div>
            </div>
        )
    }
    return (
        <div>
            {/* <ToastContainer /> */}
            <DeleteModal open={openDeleteModal} ref={deleteSubRef} onClose={() => setOpenDeleteModal(false)} mode="subject" />
            <div className="container p-0">
                <Accordion flush={true}>
                    {years.map((year, index) => {
                        return (
                            <CollapseArcadian index={index} year={year}><TableSubjects setOpenModal={setOpenModal} setOpenDeleteModal={setOpenDeleteModal} deleteSubRef={deleteSubRef} data={filterSubjects(subjects, year, sem)} /></CollapseArcadian>
                        )
                    })}
                </Accordion>
            </div>
        </div>
    )
}
export default YearCollapseSubject